import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import LeadsContext from '@/modules/leads/contexts/LeadsContext';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';
import TableHead from './TableHead/TableHead';
import TableBody from './TableBody/TableBody';

const Component = (props) => {
    // noinspection JSCheckFunctionSignatures
    const leadsContext = useContext(LeadsContext);

    return (
        <TableContainer responsive={true}>
            <Table>
                <TableHead/>
                <TableBody cols={leadsContext.cols} {...props}/>
            </Table>
        </TableContainer>
    );
};

Component.propTypes = {
    leads: PropTypes.array.isRequired,
    onContextMenu: PropTypes.func.isRequired,
};

export default Component;
